import { render } from "./CIS-Controls-Resources.vue?vue&type=template&id=d9f58940&scoped=true"
import script from "./CIS-Controls-Resources.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Resources.vue?vue&type=script&lang=js"

import "./CIS-Controls-Resources.vue?vue&type=style&index=0&id=d9f58940&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f58940"]])

export default __exports__